/**
 * Single blog post – Rank Math FAQ accordion inside .theme-dev-faq.
 */
(function () {
	'use strict';

	const handleFaqToggle = (item, items) => {
		const question = item.querySelector('.rank-math-question');
		const answer = item.querySelector('.rank-math-answer');

		if (!question || !answer) {
			return;
		}

		const isOpen = item.classList.contains('is-open');

		items.forEach((sibling) => {
			const siblingQuestion = sibling.querySelector('.rank-math-question');
			const siblingAnswer = sibling.querySelector('.rank-math-answer');

			sibling.classList.remove('is-open');

			if (siblingQuestion) {
				siblingQuestion.setAttribute('aria-expanded', 'false');
			}

			if (siblingAnswer) {
				siblingAnswer.setAttribute('hidden', '');
			}
		});

		if (!isOpen) {
			item.classList.add('is-open');
			question.setAttribute('aria-expanded', 'true');
			answer.removeAttribute('hidden');
		}
	};

	const initBlogFaqAccordion = () => {
		const faqSections = document.querySelectorAll('.blog-detail-text .theme-dev-faq');

		faqSections.forEach((section) => {
			const items = section.querySelectorAll('.rank-math-list-item');

			items.forEach((item, index) => {
				const question = item.querySelector('.rank-math-question');
				const answer = item.querySelector('.rank-math-answer');

				if (!question || !answer) {
					return;
				}

				question.setAttribute('role', 'button');
				question.setAttribute('tabindex', '0');

				if (index === 0) {
					item.classList.add('is-open');
					question.setAttribute('aria-expanded', 'true');
					answer.removeAttribute('hidden');
				} else {
					question.setAttribute('aria-expanded', 'false');
					answer.setAttribute('hidden', '');
				}

				question.addEventListener('click', () => {
					handleFaqToggle(item, items);
				});

				question.addEventListener('keydown', (event) => {
					if (event.key !== 'Enter' && event.key !== ' ') {
						return;
					}

					event.preventDefault();
					handleFaqToggle(item, items);
				});
			});

			section.classList.add('is-initialized');
		});
	};

	document.addEventListener('DOMContentLoaded', initBlogFaqAccordion);
})();
